/* eslint-disable custom/no-nested-ternary */

import DOM from '@common/DOM/DOM'
import { is } from '@common/is/is'

import type { ICanvas, IBaseCanvasProps } from './definitions'

// Ezt csak úgy ne írd át, mert van játék, ahol ehhez képest állítottuk be a z-t!
const DEFAULT_Z = 1

/**
 * Canvas elem létrehozása és a hozzá tartozó contextussal visszaadja.
 * @example
 * <canvas height="600" width="800"></canvas>
 *
 * Support:
 * IE:      9+  (2011)
 * Edge:   12+  (2015)
 * FF:      3.6 (2006)
 * Chrome:  4   (2010)
 * @see {@link https://caniuse.com/#search=canvas}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API}
 * @param props - Létrehozni kívánt canvas paraméterei.
 */
export default function createCanvas (props: IBaseCanvasProps): ICanvas | null {
  // Ha nem támogatja az eszköz a canvas-t, akkor hagyjuk az egészet
  if (!DOM.isCanvasSupported()) {
    return null
  }

  const canvas = document.createElement('canvas')
  canvas.setAttribute('width', `${ props.width }`)
  canvas.setAttribute('height', `${ props.height }`)

  // Class hozzáadása
  if (props.className) {
    canvas.classList.add(props.className)
  }

  const top = is.number(props.top)
    ? `${ props.top }px`
    : is.string(props.top)
      ? props.top
      : '0'

  const left = is.number(props.left)
    ? `${ props.left }px`
    : is.string(props.left)
      ? props.left
      : '0'

  canvas.style.top      = top
  canvas.style.left     = left
  canvas.style.position = 'absolute'
  canvas.style.zIndex   = `${ props.z ?? DEFAULT_Z }`
  canvas.style.border   = props.canDebug ? '1px solid red' : ''

  const ctx = canvas.getContext('2d', {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    alpha: is.undefined(props.hasAlpha)
      ? true
      : props.hasAlpha
  }) as CanvasRenderingContext2D // Castolunk, mert itt már biztos, hogy van ctx.

  return { canvas, ctx }
}
